import { Button } from '@mui/material';
import { useContext } from '../../context.jsx';
import { useRenameContext } from './rename-context.jsx';

export function RenameButton() {
  const { setRenaming } = useRenameContext();
  const { tab, getSelectedInstances } = useContext();
  const instances = getSelectedInstances();

  return tab !== 'instances' ? null : (
    <Button disabled={!instances?.length} onClick={() => setRenaming(true)}>
      Rename
    </Button>
  );
}
